import { render, staticRenderFns } from "./VideoHost.vue?vue&type=template&id=9302940c&scoped=true"
import script from "./VideoHost.vue?vue&type=script&lang=ts"
export * from "./VideoHost.vue?vue&type=script&lang=ts"
import style0 from "./VideoHost.vue?vue&type=style&index=0&id=9302940c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9302940c",
  null
  
)

export default component.exports